import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 py-5 space-y-6" }
const _hoisted_2 = { class: "pb-4 border-b border-capGrey border-opacity-30" }
const _hoisted_3 = { class: "text-lg font-semibold text-capDarkPurple" }
const _hoisted_4 = { class: "text-sm text-capGrey" }
const _hoisted_5 = { class: "text-sm text-capGrey" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xs font-semibold text-capDarkPurple uppercase tracking-widest mb-3" }, "Payment Methods on File", -1)
const _hoisted_7 = {
  key: 0,
  class: "h-16 flex items-center justify-center"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-capGrey"
}
const _hoisted_9 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-capGrey mb-1" }, "Type", -1)
const _hoisted_12 = { class: "h-5 flex items-center text-sm text-capDarkPurple whitespace-nowrap" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "text-xs text-capGrey mb-1" }
const _hoisted_15 = { class: "h-5 flex items-center text-sm text-capDarkPurple whitespace-nowrap" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "text-xs text-capGrey mb-1" }
const _hoisted_18 = { class: "h-5 flex items-center text-sm text-capDarkPurple whitespace-nowrap" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-capGrey mb-1" }, "Default", -1)
const _hoisted_21 = { class: "h-5 flex items-center" }
const _hoisted_22 = ["checked", "onClick"]
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-capGrey mb-1" }, "Delete", -1)
const _hoisted_25 = { class: "h-5 flex items-center relative group" }
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = {
  key: 0,
  role: "tooltip",
  class: "pointer-events-none absolute bottom-full right-0 mb-2 w-48 rounded-md bg-capDarkPurple px-2 py-1.5 text-xs text-white opacity-0 transition-opacity duration-75 group-hover:opacity-100 z-10 text-center"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xs font-semibold text-capDarkPurple uppercase tracking-widest mb-3" }, "New Payment Method", -1)
const _hoisted_30 = {
  key: 0,
  class: "flex gap-6 mb-4"
}
const _hoisted_31 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-capDarkPurple text-sm select-none" }, "Credit Card", -1)
const _hoisted_33 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-capDarkPurple text-sm select-none" }, "ACH", -1)
const _hoisted_35 = {
  key: 1,
  id: "cap-card-container",
  class: "min-h-[90px]"
}
const _hoisted_36 = {
  key: 2,
  class: "space-y-3"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "text-capGrey text-xs block mb-1" }, "Name on Account", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "text-capGrey text-xs block mb-1" }, "Routing Number", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "text-capGrey text-xs block mb-1" }, "Account Number", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "text-capGrey text-xs block mb-1" }, "Account Type", -1)
const _hoisted_41 = { class: "flex gap-4" }
const _hoisted_42 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "text-capDarkPurple text-sm select-none" }, "Checking", -1)
const _hoisted_44 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "text-capDarkPurple text-sm select-none" }, "Savings", -1)
const _hoisted_46 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-capDarkPurple text-sm select-none" }, "Business Checking", -1)
const _hoisted_48 = {
  key: 3,
  class: "mt-2 text-sm text-red-500"
}
const _hoisted_49 = { class: "mt-4 flex gap-3" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "px-8 pt-8 pb-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-capDarkPurple text-sm" }, "This action will delete the payment and cannot be undone.")
], -1)

import { ref, computed, watch, nextTick, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification'
import { TrashIcon } from '@heroicons/vue/solid'
import CDrawer from '@/components/ui/CDrawer.vue'
import CButton from '@/components/ui/CButton.vue'
import SharedAPI from '@/api/SharedAPI'
import { getFmError } from '@/api/fmError'
import { splitAddressLabel } from '@/composables/useAddressLabel'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodsDrawer',
  props: {
    modelValue: { type: Boolean, required: true },
    contractId: { type: String, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

const toast = useToast()




const isOpen = computed({
    get: () => props.modelValue,
    set: (val: boolean) => emit('update:modelValue', val),
})

const store = useStore()
const contract = computed(() => store.state.contract)
const addressLabel = computed(() => splitAddressLabel(contract.value.zctWebPhysicalAddressLabel))

// physicalAddrCountry isn't consistently populated on the FileMaker side, so
// a recognized value is trusted first; otherwise fall back to sniffing a
// Canadian postal code (letter-digit-letter digit-letter-digit, e.g.
// "A1A 1A1") out of the address label, which never overlaps with a US
// ZIP/ZIP+4.
const CANADIAN_POSTAL_CODE_PATTERN = /\b[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d\b/
const isCanadianProperty = computed(() => {
    const country = (contract.value.physicalAddrCountry || '').trim().toLowerCase()
    if (['canada', 'ca', 'can'].includes(country)) return true
    return CANADIAN_POSTAL_CODE_PATTERN.test(contract.value.zctWebPhysicalAddressLabel || '')
})

const savedPaymentMethods = computed(() => {
    const raw = contract.value.zctPaymentMethodArray
    if (!raw) return []
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    // NOTE: FileMaker sends ACH entries through the same 'Card Brand' / 'Card
    // Exp' / 'Card Last 4' keys as credit cards (not ideal, but matches what
    // the backend currently returns for both payment types).
    const methods = Object.values(parsed).map((method: any) => ({
        id: method['ID'],
        type: method['Card Brand'],
        exp: method['Card Exp'],
        last4: method['Card Last 4'],
        isPrimary: method['isPrimary'],
    }))
    // Keep the default pinned to the top; falls back to whatever order
    // FileMaker returned when none is flagged (matches defaultPaymentMethodId below).
    return methods.sort((a, b) => (a.isPrimary === '1' ? 0 : 1) - (b.isPrimary === '1' ? 0 : 1))
})

// FM data isn't guaranteed to flag a default yet, so fall back to treating
// the first entry in the list as the default until isPrimary is populated.
const defaultPaymentMethodId = computed(() => {
    const flagged = savedPaymentMethods.value.find((method) => method.isPrimary === '1')
    return flagged ? flagged.id : savedPaymentMethods.value[0]?.id
})

const showAddForm = ref(false)
const isSubmitting = ref(false)
const formError = ref('')
const isCardsBusy = ref(false)

const paymentType = ref<'card' | 'ach'>('card')
const achNameOnAccount = ref('')
const achRoutingNumber = ref('')
const achAccountNumber = ref('')
const achAccountType = ref<'checking' | 'savings' | 'businessChecking'>('checking')

const showDeleteConfirm = ref(false)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const paymentMethodPendingDelete = ref<any>(null)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let stripeInstance: any = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let stripeCard: any = null

const stripePublishableKey = computed(() => contract.value.zctStripeAccountPk)
const authNetPublicKey = computed(() => contract.value.zctAuthNetPublicKey)
const authNetLoginId = computed(() => contract.value.zctAuthNetLoginID)

watch(() => props.modelValue, async (isNowOpen) => {
    if (!isNowOpen) {
        showAddForm.value = false
        formError.value = ''
        showDeleteConfirm.value = false
        paymentMethodPendingDelete.value = null
        resetAchFields()
        await destroyStripeCard()
    }
})

watch(paymentType, async (type) => {
    formError.value = ''
    if (type === 'ach') {
        await destroyStripeCard()
    } else {
        resetAchFields()
        await nextTick()
        await initStripeCard()
    }
})

function resetAchFields() {
    achNameOnAccount.value = ''
    achRoutingNumber.value = ''
    achAccountNumber.value = ''
    achAccountType.value = 'checking'
}

async function openAddForm() {
    showAddForm.value = true
    paymentType.value = 'card'
    formError.value = ''
    resetAchFields()
    await nextTick()
    await initStripeCard()
}

async function cancelAddForm() {
    showAddForm.value = false
    formError.value = ''
    resetAchFields()
    await destroyStripeCard()
}

async function initStripeCard() {
    const Stripe = (window as any).Stripe
    if (!Stripe) {
        formError.value = 'Payment form unavailable. Please refresh the page.'
        return
    }
    if (!stripePublishableKey.value) {
        console.error('[PaymentMethodsDrawer] initStripeCard: contract.zctStripeAccountPk is not set')
        formError.value = 'Payment form is not configured. Please contact support.'
        return
    }
    try {
        stripeInstance = Stripe(stripePublishableKey.value)
        const elements = stripeInstance.elements()
        stripeCard = elements.create('card')
        stripeCard.mount('#cap-card-container')
    } catch (e) {
        console.error('[PaymentMethodsDrawer] initStripeCard:', e)
        formError.value = 'Failed to load payment form.'
    }
}

async function destroyStripeCard() {
    if (stripeCard) {
        try { stripeCard.unmount() } catch { /* ignore */ }
        stripeCard = null
        stripeInstance = null
    }
}

async function handleSave() {
    if (paymentType.value === 'ach') {
        await handleSaveAch()
    } else {
        await handleSaveCard()
    }
}

async function handleSaveCard() {
    if (!stripeCard || !stripeInstance || isSubmitting.value) return
    isSubmitting.value = true
    formError.value = ''
    try {
        const { token, error } = await stripeInstance.createToken(stripeCard)
        if (error) {
            formError.value = error.message ?? 'Tokenization failed.'
            return
        }
        const res = await SharedAPI.runScript(
            'Web - Create Payment Method',
            JSON.stringify({
                stripeToken: token.id,
                contractID: props.contractId,
                isAuth: '0',
            })
        )
        const fmError = getFmError(res)
        if (fmError) {
            formError.value = fmError
            return
        }
        await destroyStripeCard()
        showAddForm.value = false
        await refreshContract()
    } catch (e: any) {
        console.error('[PaymentMethodsDrawer] handleSaveCard:', e)
        formError.value = e?.message ?? 'Failed to save card. Please try again.'
    } finally {
        isSubmitting.value = false
    }
}

async function handleSaveAch() {
    if (isSubmitting.value) return
    isSubmitting.value = true
    formError.value = ''
    try {
        if (!authNetPublicKey.value || !authNetLoginId.value) {
            console.error('[PaymentMethodsDrawer] handleSaveAch: contract.zctAuthNetPublicKey or zctAuthNetLoginID is not set')
            formError.value = 'Payment form is not configured. Please contact support.'
            return
        }
        const Accept = (window as any).Accept
        if (!Accept) {
            formError.value = 'Payment form unavailable. Please refresh the page.'
            return
        }

        const secureData = {
            authData: {
                clientKey: authNetPublicKey.value,
                apiLoginID: authNetLoginId.value,
            },
            bankData: {
                nameOnAccount: achNameOnAccount.value,
                routingNumber: achRoutingNumber.value,
                accountNumber: achAccountNumber.value,
                accountType: achAccountType.value,
            },
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response = await new Promise<any>((resolve) => {
            Accept.dispatchData(secureData, resolve)
        })

        if (response?.messages?.resultCode !== 'Ok') {
            formError.value = response?.messages?.message?.[0]?.text ?? 'Tokenization failed.'
            return
        }

        const res = await SharedAPI.runScript(
            'Web - Create Payment Method',
            JSON.stringify({
                contractID: props.contractId,
                isAuth: '1',
                dataDescriptor: response.opaqueData.dataDescriptor,
                dataValue: response.opaqueData.dataValue,
            })
        )
        const error = getFmError(res)
        if (error) {
            formError.value = error
            return
        }
        resetAchFields()
        showAddForm.value = false
        await refreshContract()
    } catch (e: any) {
        console.error('[PaymentMethodsDrawer] handleSaveAch:', e)
        formError.value = e?.message ?? 'Failed to save payment method. Please try again.'
    } finally {
        isSubmitting.value = false
    }
}

async function refreshContract() {
    isCardsBusy.value = true
    try {
        const params = [{ '__kptID': props.contractId }]
        const res = await SharedAPI.performFind(params, 'contract_detail', false, 'set_globals', props.contractId)
        store.commit('setContractDetails', res.response.data[0].fieldData)
    } catch (e) {
        console.error('[PaymentMethodsDrawer] refreshContract:', e)
    } finally {
        isCardsBusy.value = false
    }
}

async function setDefaultPaymentMethod(method: any) {
    if (isCardsBusy.value || method.id === defaultPaymentMethodId.value) return
    isCardsBusy.value = true
    try {
        const params = {
            paymentMethodID: method.id,
            contractID: props.contractId,
        }
        const res = await SharedAPI.runScript('Web - Set Default Payment Method', JSON.stringify(params))
        const error = getFmError(res)
        if (error) {
            toast.error(error)
            return
        }
        await refreshContract()
    } catch (e) {
        console.error('[PaymentMethodsDrawer] setDefaultPaymentMethod:', e)
        toast.error('Failed to set default payment method. Please try again.')
    } finally {
        isCardsBusy.value = false
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isDeleteDisabled(method: any): boolean {
    return savedPaymentMethods.value.length <= 1 || method.id === defaultPaymentMethodId.value
}

function openDeleteConfirm(method: any) {
    if (isDeleteDisabled(method)) return
    paymentMethodPendingDelete.value = method
    showDeleteConfirm.value = true
}

function closeDeleteConfirm() {
    showDeleteConfirm.value = false
    paymentMethodPendingDelete.value = null
}

async function confirmDelete() {
    const method = paymentMethodPendingDelete.value
    if (!method || isCardsBusy.value) return
    closeDeleteConfirm()
    isCardsBusy.value = true
    try {
        const params = {
            paymentMethodID: method.id,
            contractID: props.contractId,
        }
        const res = await SharedAPI.runScript('Web - Delete Payment Method', JSON.stringify(params))
        const error = getFmError(res)
        if (error) {
            toast.error(error)
            return
        }
        await refreshContract()
    } catch (e) {
        console.error('[PaymentMethodsDrawer] confirmDelete:', e)
        toast.error('Failed to delete payment method. Please try again.')
    } finally {
        isCardsBusy.value = false
    }
}

onUnmounted(() => {
    destroyStripeCard()
})

return (_ctx: any,_cache: any) => {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CDrawer, {
      modelValue: _unref(isOpen),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(isOpen) ? (isOpen).value = $event : null)),
      title: "Payment Methods"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(contract).contractNumberDisplay), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(addressLabel).street), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(addressLabel).cityStateZip), 1)
          ]),
          _createElementVNode("section", null, [
            _hoisted_6,
            (isCardsBusy.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_loading)
                ]))
              : (_unref(savedPaymentMethods).length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " No payment methods currently on file. "))
                : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(savedPaymentMethods), (method) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: method.id,
                        class: "flex items-start justify-between border border-capGrey border-opacity-30 rounded-md px-4 py-3"
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, _toDisplayString(method.type), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(method.type === 'ACH' ? 'Routing' : 'Exp.'), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(method.exp), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(method.type === 'ACH' ? 'Account Last 6' : 'Last 4'), 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(method.last4), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: method.id === _unref(defaultPaymentMethodId),
                              onClick: _withModifiers(($event: any) => (setDefaultPaymentMethod(method)), ["prevent"]),
                              class: "h-4 w-4 rounded border-gray-300 cursor-pointer text-capPurple focus:ring-capPurple",
                              "aria-label": "Set as default payment method"
                            }, null, 8, _hoisted_22)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              type: "button",
                              disabled: isDeleteDisabled(method),
                              onClick: ($event: any) => (openDeleteConfirm(method)),
                              class: _normalizeClass(isDeleteDisabled(method) ? 'text-capGrey cursor-not-allowed' : 'text-red-500 hover:text-red-700 transition-colors'),
                              "aria-label": "Delete payment method"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                            ], 10, _hoisted_26),
                            (isDeleteDisabled(method))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, " You must set another default payment method before deleting this payment method. "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createElementVNode("section", null, [
            (!showAddForm.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "w-full border-2 border-dashed border-capPurple text-capPurple rounded-md py-3 text-sm font-medium hover:bg-capLightPurple hover:bg-opacity-10 transition-colors",
                  onClick: openAddForm
                }, " + Add New Payment Method "))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  (!_unref(isCanadianProperty))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentType).value = $event)),
                            value: "card",
                            class: "h-4 w-4 text-capPurple focus:ring-capPurple cursor-pointer"
                          }, null, 512), [
                            [_vModelRadio, paymentType.value]
                          ]),
                          _hoisted_32
                        ]),
                        _createElementVNode("label", _hoisted_33, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentType).value = $event)),
                            value: "ach",
                            class: "h-4 w-4 text-capPurple focus:ring-capPurple cursor-pointer"
                          }, null, 512), [
                            [_vModelRadio, paymentType.value]
                          ]),
                          _hoisted_34
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (paymentType.value === 'card')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                    : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", null, [
                          _hoisted_37,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((achNameOnAccount).value = $event)),
                            type: "text",
                            class: "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-capDarkPurple placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                          }, null, 512), [
                            [_vModelText, achNameOnAccount.value]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_38,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((achRoutingNumber).value = $event)),
                            type: "text",
                            inputmode: "numeric",
                            class: "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-capDarkPurple placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                          }, null, 512), [
                            [_vModelText, achRoutingNumber.value]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((achAccountNumber).value = $event)),
                            type: "text",
                            inputmode: "numeric",
                            class: "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-capDarkPurple placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                          }, null, 512), [
                            [_vModelText, achAccountNumber.value]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((achAccountType).value = $event)),
                                value: "checking",
                                class: "h-4 w-4 text-capPurple focus:ring-capPurple cursor-pointer"
                              }, null, 512), [
                                [_vModelRadio, achAccountType.value]
                              ]),
                              _hoisted_43
                            ]),
                            _createElementVNode("label", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((achAccountType).value = $event)),
                                value: "savings",
                                class: "h-4 w-4 text-capPurple focus:ring-capPurple cursor-pointer"
                              }, null, 512), [
                                [_vModelRadio, achAccountType.value]
                              ]),
                              _hoisted_45
                            ]),
                            _createElementVNode("label", _hoisted_46, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((achAccountType).value = $event)),
                                value: "businessChecking",
                                class: "h-4 w-4 text-capPurple focus:ring-capPurple cursor-pointer"
                              }, null, 512), [
                                [_vModelRadio, achAccountType.value]
                              ]),
                              _hoisted_47
                            ])
                          ])
                        ])
                      ])),
                  (formError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(formError.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(CButton, {
                      loading: isSubmitting.value,
                      onClick: handleSave
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(paymentType.value === 'ach' ? 'Save ACH' : 'Save Card'), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(CButton, {
                      outline: "",
                      onClick: cancelAddForm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_50
                      ]),
                      _: 1
                    })
                  ])
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showDeleteConfirm.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40",
            onClick: _withModifiers(closeDeleteConfirm, ["self"])
          }, [
            _createElementVNode("div", { class: "bg-white rounded-lg shadow-xl w-full max-w-sm mx-4 overflow-hidden" }, [
              _hoisted_52,
              _createElementVNode("div", { class: "flex justify-end gap-3 px-8 pb-8" }, [
                _createElementVNode("button", {
                  onClick: closeDeleteConfirm,
                  class: "px-4 py-2 text-sm text-capGrey border border-capGrey rounded-md hover:bg-capGrey hover:bg-opacity-10 transition-colors"
                }, " Cancel "),
                _createElementVNode("button", {
                  onClick: confirmDelete,
                  class: "px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
                }, " Confirm ")
              ])
            ])
          ], 8, _hoisted_51))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})